import React, { useEffect, useState } from 'react';
import { Box, SxProps } from '@mui/material';
import { Checkbox } from '@europrocurement/flexy-components';
import { NoteContent } from '@europrocurement/flexy-components/components/atoms/NoteContent';
import { ApiDossiersIdNotesGet200ResponseNotesInner } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

type NotesSelectorsForm = {
    preSelectedNotesIds: number[];
    notes: ApiDossiersIdNotesGet200ResponseNotesInner[];
    setSelectedNotes: React.Dispatch<
        React.SetStateAction<ApiDossiersIdNotesGet200ResponseNotesInner[]>
    >;
    sxWrapper?: SxProps;
};

const NotesSelectorsForm: React.FunctionComponent<NotesSelectorsForm> = function ({
    preSelectedNotesIds,
    notes,
    setSelectedNotes,
    sxWrapper,
}) {
    const [selectedNotesIds, setSelectedNotesIds] = useState<number[]>([]);

    // Select ou remove selected note
    const handleSelectNote = (note: ApiDossiersIdNotesGet200ResponseNotesInner) => {
        if (note.id) {
            if (selectedNotesIds.includes(note.id)) {
                setSelectedNotesIds((state) => state.filter((id) => id !== note.id));
                setSelectedNotes((notesState) =>
                    notesState.filter((noteState) => noteState.id !== note.id),
                );
            } else {
                setSelectedNotesIds((state) => [...state, note.id as number]);
                setSelectedNotes((prevNotes) => [...prevNotes, note]);
            }
        }
    };

    // Automatically pre-check documents based on preSelectedDocumentsProps
    useEffect(() => {
        if (preSelectedNotesIds) {
            setSelectedNotesIds(preSelectedNotesIds);
            // Hydrate selectedDocuments
            setSelectedNotes(
                notes.filter((note) => note.id && preSelectedNotesIds.includes(note.id)),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [preSelectedNotesIds]);

    return (
        <Box
            sx={{
                padding: '0',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px 0',
                maxHeight: '55vh',
                overflow: 'auto',
                ...sxWrapper,
            }}
        >
            {notes.map((note) => (
                <Box
                    key={note.id}
                    sx={{
                        display: 'flex',
                        width: '100%',
                        alignItems: 'center',
                    }}
                >
                    <Checkbox
                        checked={selectedNotesIds.includes(note.id as number)}
                        onChange={() => handleSelectNote(note)}
                    />
                    <NoteContent
                        content={note.content as string}
                        enableMarkdown
                    />
                </Box>
            ))}
        </Box>
    );
};

export default NotesSelectorsForm;
